define(['underscore'], (_) => {
    return ['LocaleService', 'configBasler', 'ContextService', 'StateUtils', 'LocaleService', '$state', 'deviceDetector', 'BaslerLoggingConstants', 'VisitorIdService', 'SessionIdService',
        (locale, configBasler, ContextService, StateUtils, LocaleService, $state, deviceDetector, BaslerLoggingConstants, VisitorIdService, SessionIdService) => {

            const service = {
                getEventTypes: () => getEventTypes(),
                createLogObject: (event, error, submission) => createLogObject(event, error, submission),
                getErrorInfo: (error) => getErrorInfo(error),
                getBusinessData: (submission) => getBusinessData(submission),
                createUniqueID: () => createUniqueID(),
                getBrowserInfo: () => getBrowserInfo(),
                getBasicAppState: (quoteID) => getBasicAppState(quoteID),
                getLogInfo: (logevent, quoteId, encryptedQuoteId, sessionUuid) => getLogInfo(logevent, quoteId, encryptedQuoteId, sessionUuid),
                filterByKeys: (inputObject, allowedFunction) => filterByKeys(inputObject, allowedFunction),
                mapValues: (srcObj, regexpsForKeys, mapFunction) => mapValues(srcObj, regexpsForKeys, mapFunction),
                omitWithRegex: (srcObj, keysToExclude) => omitWithRegex(srcObj, keysToExclude),
            };

            const logInfo = {
                BUSINESS: 'business',
                DEVICEINFO: 'device',
                ERROR: 'error',
                DTO: 'dto',
                NGRX: 'ngrx',
                ESSENTIAL: 'essential',
            }

            const logInformationsPerEventType = {
                [BaslerLoggingConstants.START]: [logInfo.ESSENTIAL, logInfo.BUSINESS, logInfo.DEVICEINFO],
                [BaslerLoggingConstants.CHANGEPAGE]: [logInfo.ESSENTIAL],
                [BaslerLoggingConstants.CONTACTUS]: [logInfo.ESSENTIAL, logInfo.BUSINESS, logInfo.DEVICEINFO, logInfo.DTO, logInfo.ERROR],
                [BaslerLoggingConstants.LOAD]: [logInfo.ESSENTIAL, logInfo.BUSINESS, logInfo.DEVICEINFO],
                [BaslerLoggingConstants.TOASTERROR]: [logInfo.ESSENTIAL, logInfo.BUSINESS, logInfo.DEVICEINFO, logInfo.DTO, logInfo.ERROR],
                [BaslerLoggingConstants.BIND]: [logInfo.ESSENTIAL, logInfo.BUSINESS],
            };


            function getEventTypes() {
                return {...BaslerLoggingConstants};
            }

            function getErrorInfo(error) {
                if (!error) {
                    return undefined;
                }
                return {'message': error.message, 'name': error.name, 'stack': error.stack && error.stack.substr(0, 500) || undefined};
            }

            function getBusinessData(submission) {
                function convertCampaignArrayToObject(trackingCodes) {
                    return trackingCodes && trackingCodes.reduce((acc, curr) => {
                        acc = {...acc, [curr.codeName]: curr.codeValue}
                        return acc;
                    }, {});
                }

                function getElementIfExists(element) {
                    return typeof element !== 'undefined' ? element : undefined;
                }

                const campaigns = convertCampaignArrayToObject(submission && submission.draftData && submission.draftData.trackingCode);

                const promotion = submission && submission.draftData && submission.draftData.promotion;
                return {
                    product: ContextService.getProductCode(),
                    subproduct: ContextService.getSubproductCode(),
                    salespoint: ContextService.getSalespoint(),
                    advisor: ContextService.getAdvisorNumber(), // todo: advisornumber rein nehmen
                    employeeMode: Boolean(ContextService.isEmployeeMode()),
                    language: LocaleService.getCurrentLocale(),
                    ...(promotion && {
                        promotion: {
                            promotion: promotion && promotion.title,
                            promotion0: getElementIfExists(promotion && promotion.promotionItems[0]),
                            promotion1: getElementIfExists(promotion && promotion.promotionItems[1]),
                            promotion2: getElementIfExists(promotion && promotion.promotionItems[2]),
                        }
                    }),
                    campaign: campaigns
                };
            }

            function createUniqueID() {
                let dt = new Date().getTime();
                return 'xxxx4xxxyx'.replace(/[xy]/g, function (c) {
                    let r = (dt + Math.random() * 16) % 16 | 0; //tslint:disable-line no-bitwise
                    dt = Math.floor(dt / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); //tslint:disable-line no-bitwise
                });
            }

            function getLogInfo(event, quoteId, encryptedQuoteId, sessionUuid) {
                return {
                    'applicationgroup': 'customercontact.premiumcalculator',
                    'application': 'MF',
                    'logevent': event,
                    'requestid': service.createUniqueID(),
                    'quoteid': quoteId || undefined,
                    'sessionUUID': sessionUuid || undefined,
                    'encryptedQuoteId': encryptedQuoteId || undefined,
                    'currentPage': getCurrentPage(),
                    'timestamp': new Date().getTime(),
                    'sessionId': SessionIdService.getSessionId(),
                };
            }

            function getBrowserInfo() {
                return {
                    device: {
                        browser: deviceDetector.browser,
                        browser_version: deviceDetector.version,
                        device: deviceDetector.device,
                        os: deviceDetector.os,
                        os_version: deviceDetector.os_version,
                        userAgent: deviceDetector.raw.useragent,
                        resolution: `${window.screen && window.screen.height}x${window.screen && window.screen.width}`,
                        orientation: window.screen && window.screen.orientation && window.screen.orientation.type,
                    },
                    isMobile: deviceDetector.isMobile(),
                    isTablet: deviceDetector.isTablet(),
                    isDesktop: deviceDetector.isDesktop(),
                    route: $state.current.url,
                }
            }

            function getBasicAppState(quoteID) {
                return {
                    quoteID: quoteID,
                    design: ContextService.getChannel(),
                    language: LocaleService.getCurrentLocale(),
                    product: ContextService.getProductCode(),
                    subProduct: ContextService.getSubproductCode(),
                    currentPage: getCurrentPage(),
                };
            }

            function getCurrentPage() {
                const CURRENTPAGENAMES = {
                    quoteentry: 'RiskRelevantData',
                    mfpRiskRelevantData: 'RiskRelevantData',
                    mfpQuoteDetails: 'OfferingData',
                    mfpPersonificationQualification: 'PersonalData',
                    mfpSummary: 'SummaryData',
                    mfpConfirmation: 'ConfirmationData',
                    mfpContactUs: 'ContactUs',
                }
                const currentPageName = $state && $state.current && $state.current.name;
                return CURRENTPAGENAMES[currentPageName || ''];
            }

            function createLogObject(event, error, submissionData) {
                const submission = submissionData || (StateUtils.activeDataForState(true) && StateUtils.activeDataForState(true).model ? StateUtils.activeDataForState(true).model.value : null);
                const logInfos = logInformationsPerEventType[event];

                if (!logInfos || logInfos.length === 0) {
                    return {};
                }

                return {
                    [logInfo.ESSENTIAL]:
                        logInfos.includes(logInfo.ESSENTIAL)
                            ? service.getLogInfo(
                            event,
                            submission && submission.quoteID,
                            submission && submission.draftData.encryptedQuoteID,
                            submission && submission.sessionUUID)
                            : undefined,
                    [logInfo.ERROR]: logInfos.includes(logInfo.ERROR) ? service.getErrorInfo(error) : undefined,
                    [logInfo.BUSINESS]: logInfos.includes(logInfo.BUSINESS) ? service.getBusinessData(submission) : undefined,
                    [logInfo.DEVICEINFO]: logInfos.includes(logInfo.DEVICEINFO) ? service.getBrowserInfo() : undefined,
                    [logInfo.NGRX]: logInfos.includes(logInfo.NGRX) ? service.getBasicAppState(submission && submission.quoteID) : undefined,
                    [logInfo.DTO]: logInfos.includes(logInfo.DTO) ? submission : undefined,
                };
            }

            /** TS: function filterByKeys(inputObject: any, allowedFunction: (key: string) => boolean) */
            function filterByKeys(inputObject, allowedFunction) {
                if (!inputObject || !allowedFunction) {
                    return inputObject;
                }
                return Object
                    .entries(inputObject)
                    .filter(entry => allowedFunction(entry[0]))
                    .reduce((obj, entry) => {
                        obj[entry[0]] = entry[1];
                        return obj;
                    }, {});
            }

            /**
             * Map values of 'srcObj' using mapFunction.
             * Expects 'srcObj' in flattended format.
             *
             * TS: mapValues(srcObj: any, regexpsForKeys: RegExp[] = [], mapFunction: (key: string, value: string ) => string): any
             */
            function mapValues(srcObj, regexpsForKeys = [], mapFunction) {
                if (!srcObj || !regexpsForKeys || !mapFunction) {
                    return srcObj;
                }
                const allowedKeys = key => regexpsForKeys.some(regex => regex.test(key));
                const filteredObj = filterByKeys(srcObj, allowedKeys);
                const mappedObj = _.mapObject(filteredObj, (value, key) => mapFunction(key, value));
                return {
                    ...srcObj,
                    ...mappedObj,
                };
            }

            /**
             * TS: omitWithRegex(srcObj: any, keysToExclude: RegExp[] = []): any
             */
            function omitWithRegex(srcObj, keysToExclude = []) {
                if (!srcObj || (keysToExclude || []).length === 0) {
                    return srcObj;
                } else {
                    return _.omit(srcObj, (value, key, obj) => keysToExclude.some(regex => regex.test(key)));
                }
            }


            return service;
        }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/LoggingDataService.js